"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamToJSON = exports.TeamFromJSONTyped = exports.TeamFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function TeamFromJSON(json) {
    return TeamFromJSONTyped(json, false);
}
exports.TeamFromJSON = TeamFromJSON;
function TeamFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': json['_id'],
        'tournament': _1.TournamentFromJSON(json['tournament']),
        'name': json['name'],
        'startTime': json['startTime'],
        'startHole': json['startHole'],
        'identifier': !runtime_1.exists(json, 'identifier') ? undefined : json['identifier'],
        'teamHandicap': !runtime_1.exists(json, 'teamHandicap') ? undefined : json['teamHandicap'],
        'creationDate': json['creationDate'],
        'lastUpdated': json['lastUpdated'],
    };
}
exports.TeamFromJSONTyped = TeamFromJSONTyped;
function TeamToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'tournament': _1.TournamentToJSON(value.tournament),
        'name': value.name,
        'startTime': value.startTime,
        'startHole': value.startHole,
        'identifier': value.identifier,
        'teamHandicap': value.teamHandicap,
        'creationDate': value.creationDate,
        'lastUpdated': value.lastUpdated,
    };
}
exports.TeamToJSON = TeamToJSON;
